import moment from 'moment';
import { FilterType, ServiceType } from 'utilities/enum-utils';

export type BookingsViewType = 'list' | 'calendar';

const availableBookingFilters: FilterType[] = [
  FilterType.CUSTOMER,
  FilterType.WORKER,
  FilterType.SERVICE,
  FilterType.BOOKING_STATUS,
  FilterType.RECURRING,
  FilterType.PAYMENT_STATUS,
  FilterType.SHIFT_SLOT_STATUS,
  FilterType.FUNDING_SOURCES,
  FilterType.BOOKING_ERROR_TYPES,
  FilterType.SHOW_ARCHIVED_BOOKINGS,
  FilterType.PINNED_ALERTS,
  FilterType.BOOKING_TYPES,
  FilterType.SERVICE_TYPE,
  FilterType.LOCATION_BY_SUBURBS,
];

export const availableFiltersRoster: FilterType[] = [...availableBookingFilters];

export const availableFiltersList: FilterType[] = [
  ...availableBookingFilters,
  FilterType.SLEEPOVER,
  FilterType.DATE_RANGE,
  FilterType.BOOKING_BILLING,
];

export const defaultFilterValue = [
  {
    [FilterType.DATE_RANGE]: [moment().startOf('isoWeek').toISOString(), moment().endOf('isoWeek').toISOString()],
  },
  { sort: [['startDateTime', 'asc']] },
  { [FilterType.CUSTOMER]: [] },
  { [FilterType.WORKER]: [] },
  { [FilterType.SHIFT_SLOT_STATUS]: [] },
  { [FilterType.SERVICE_TYPE]: [ServiceType.INDIVIDUAL] },
];

export type BookingsViewLayoutType = 'compact' | 'regular';
